/**
 * ツアー詳細画面用JavaScript
 */
$(document).ready(function() {
    //リファラから出発日パラメーターを取得する
    var depRegex = new RegExp(/depDate=([0-9]+)/i);
    var checkRef = document.referrer.match(depRegex);
    var depDate,depYear,depMonth;
    if ( checkRef ){
        depDate = checkRef[1];
        if ( depDate ){
            depYear = depDate.substring(0,4);
            depMonth = depDate.substring(4,6);
        }
    }
    if ( depYear && depMonth ){
        let month = depYear+'-'+parseInt(depMonth);
        if ( $('.'+month).length ){
            $('.box--month_list_item.-enable.-active').removeClass('-active');
            $('.box--month_btn').removeClass('-active');
            $('.box--calender_wrap.-active').removeClass('-active');
            $('.box--month_list_item.-enable[month='+month+']').addClass('-active');
            $('.box--calender_wrap.' + month ).addClass('-active');
        }
    }

    // カレンダー月選択
    $('.box--month_list_item.-enable').click(function() {
        let month = $(this).attr('month');
        $('.box--month_list_item.-enable.-active').removeClass('-active');  // 「月選択」ボタンを非活性
        $('.box--month_btn').removeClass('-active');                // 「全て表示する」ボタンを非活性
        $('.box--calender_wrap.-active').removeClass('-active');    // 全カレンダーを非表示
        $(this).addClass('-active');                                // 該当「月選択」ボタンを活性
        $('.box--calender_wrap.' + month).addClass('-active');      // 該当月カレンダーを表示
    });
    // 全てのカレンダーを表示
    $('.box--month_btn').click(function () {
        $('.box--month_list_item.-enable.-active').removeClass('-active');  // 月選択ボタン
        $('.box--calender_wrap.-active').removeClass('-active');    // 全カレンダーを非表示
        $(this).addClass('-active');        // 「全て表示する」ボタンを活性
        $('.box--calender_wrap.-sp_none').addClass('-active');       // PC用カレンダーを全て表示
    });
    // お気に入りボタン設定
    setFavoriteButton();
    // お気に入りリスト表示
    $('.Favorite--link').click(function() {
        openFavoriteList();
    });

    $('.related_hotel a').on('click',function(){
        console.log('hotel_open');
        $(this).parent().parent().next().slideToggle();
    });
    
    addHistory();   // 閲覧履歴追加

    //トリップアドバイザー
    var hotelcodes = [];
    $('.tripadvisor_reviews').map(function(){
            hotelcodes.push($(this).data('hotelcode'));
    });
    if ( hotelcodes.length ){
        $.ajax({
                type: "POST",
                url: "https://stworld.jp/ta_api/get_reviews/",
                data: { hotelcodes: hotelcodes.join(",") },
                dataType: "json",
                success: function ( j ){
                        $.each(j,function(idx,val){
                                $('[data-hotelcode="'+idx+'"]').show();
                                $('[data-hotelratingimg="'+idx+'"]').attr("src",val.rating_image_url);
                                $('.item--hotel_rating').show();
                        });
                }
        });
}
});

/**
 * お気に入りボタン設定
 */
function setFavoriteButton() {
    $('a.-favorite').removeClass('-active');
    $('a.-favorite').children('span').text('お気に入り登録する');
    // お気に入り登録済み設定
    const tcd = $('#tour_data').attr('tcd');
    const orgFavData = localStorage.getItem('stw_fav');
    if (orgFavData) {
        const favData = JSON.parse(orgFavData);
        if (favData.some(favorite => favorite.tcd === tcd)) {
            $('a.-favorite').addClass('-active');
            $('a.-favorite').children('span').text('お気に入り登録済み');
        }
    }
    // お気に入り登録
    $('.-favorite').onclick = "";
    $('a.-favorite').not('.-active').click(function () {
        const tcd = $('#tour_data').attr('tcd');
        const orgFavData = localStorage.getItem('stw_fav');
        let favData = new Array();
        if (orgFavData) {
            favData = JSON.parse(orgFavData);

            if (favData.some(favorite => favorite.tcd === tcd)) {
                // alert("既に登録済みです。");
                // $('.Favorite--link').click();
                return false;
            }
            if (favData.length >= 5) {
                alert("既に5件ご登録されています。");
                $('.Favorite--link').click();
                return false;
            }
        } else {
            // $('.Favorite--link').show();
        }
        var favVal = {
            tcd: $('#tour_data').attr('tcd'),
            dep: $('#tour_data').attr('dep'),
            toshi: $('#tour_data').attr('toshilist'),
            term: $('#tour_data').attr('term'),
            title: $('#tour_data').attr('title'),
            inq: $('#tour_data').attr('inq'),
            price: $('#tour_data').attr('price'),
            image: $('#tour_data').attr('image')
        };
        favData.push(favVal);
        localStorage.setItem('stw_fav', JSON.stringify(favData));
        $('a.-favorite').addClass('-active');
        $('a.-favorite').children('span').text('お気に入り登録済み');
        genarateFavoriteList();         // お気に入りリスト生成 /js/pages/layouts/layout.js
        //alert('お気に入りに追加しました。');
        openFavoriteList();
        return false;
    });
}

/**
 * お気に入りリスト表示
 */
function openFavoriteList() {
    $('.tour--box_wrap.-favorite').addClass('-open');
    $('body').addClass("-fixed");
    $('body').click(function () {
        $('.tour--box_wrap.-favorite').removeClass('-open');
        $('body').removeClass("-fixed");
    });
    return false;
}

/**
 * 閲覧履歴追加
 */
function addHistory() {
    const tourCode = $('#tour_data').attr('tcd');
    if (!tourCode) {
        return false;
    }
    const orgHistory = $.cookie('stw_history');
    let histories = []
    if (orgHistory) {
        histories = JSON.parse(orgHistory);
        const index = histories.findIndex(history => history.tcd === tourCode);
        if (index != -1) {
            // 既にツアーコードが存在する場合は削除して追加
            histories.splice(index, 1);
        }
    }
    // Cookieに登録
    const history = {
        tcd: $('#tour_data').attr('tcd'),
        dep: $('#tour_data').attr('dep'),
        toshi: $('#tour_data').attr('toshilist'),
        term: $('#tour_data').attr('term'),
        title: $('#tour_data').attr('title'),
        inq: $('#tour_data').attr('inq'),
        price: $('#tour_data').attr('price'),
        image: $('#tour_data').attr('image')
    }
    histories.unshift(history);
    histories = histories.slice(0, 10);
    $.cookie('stw_history', JSON.stringify(histories), { path: '/' });
    const orgHistory2 = $.cookie('stw_history');
    return false;
}